import { observable, runInAction } from 'mobx';
import { BCTHTTKHModel, BCTaiTroModel, IMarketingCampaignServices } from 'services/Main/marketingCampaign_services';
import { DataResponse } from 'services/response';

export type MarketingCampaignStore = {
  //    Báo cáo ds tài trợ- quà tặng kh
  baocaoQuaTangKH: DataResponse<Array<BCTaiTroModel>>
  //    Báo cáo Tổng hợp tài trợ khách hành
  baocaoTaiTroKH: DataResponse<Array<BCTHTTKHModel>>
};

export interface IMarketingCampaignPresenter {
  createStore(): MarketingCampaignStore;
  // Hàm lấy data báo cáo ds tài trợ - quà tặng kh
  getDataDSTTQTKH(store: MarketingCampaignStore, data: object): Promise<void>
  // export report
  exportReport(data: object): Promise<void>


  // //    Báo cáo Tổng hợp tài trợ khách hành
  getDataTHTTKH(store: MarketingCampaignStore, data: object): Promise<void>
  // export excel Báo cáo tổng hợp tài trợ khách hàng
  exportTHTTKH(data: object): Promise<void>
}

export function createMarketingCampaignPresenter({ marketingCampaignService }: { marketingCampaignService: IMarketingCampaignServices }): IMarketingCampaignPresenter {
  return {
    createStore: (): MarketingCampaignStore =>
      observable({
        baocaoQuaTangKH: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        //    Báo cáo Tổng hợp tài trợ khách hành
        baocaoTaiTroKH: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        }
      }),
    // Hàm lấy data báo cáo ds tài trợ - quà tặng kh
    getDataDSTTQTKH: async (store, dataSearch) => {
      try {
        const result = await marketingCampaignService.getDataReportDSTTQTKH(dataSearch);
        runInAction(() => {
          store.baocaoQuaTangKH.data = result.data;
          store.baocaoQuaTangKH.isSuccess = result.isSuccess;
          store.baocaoQuaTangKH.message = result.message;
          store.baocaoQuaTangKH.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // export report
    exportReport: async (data) => {
      try {
        await marketingCampaignService.exportReport(data);
      } catch (error) {
        console.log(error);
      }
    },

    //    Báo cáo Tổng hợp tài trợ khách hành
    getDataTHTTKH: async (store, dataSearch) => {
      try {
        const result = await marketingCampaignService.getDataReportTHTTKH(dataSearch);
        runInAction(() => {
          store.baocaoTaiTroKH.data = result.data;
          store.baocaoTaiTroKH.isSuccess = result.isSuccess;
          store.baocaoTaiTroKH.message = result.message;
          store.baocaoTaiTroKH.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // export excel Báo cáo tổng hợp tài trợ khách hàng
    exportTHTTKH: async (data) => {
      try {
        await marketingCampaignService.exportTHTTKH(data);
      } catch (error) {
        console.log(error);
      }
    },
  };
}
